/**
 * Created by BlueFocus5 on 2016-11-07.
 */

import _ from 'lodash';
import { observable, autorun, action, toJS, computed, extendObservable, extendShallowObservable, map } from 'mobx';
import axios from 'axios';
import Locale from 'browser-locale';

class Settings {

  @observable settings = {};
  @observable instance = {};
  @observable active = false;
  @observable activeIdLayer = -1;
  @observable type = 'none';
  @observable toolbarOpen = false;

  @observable firstUpload = false;
  @observable firstUploadAccepted = false;
  @observable firstUploadAutoRunUpload = false;

  @observable mediaList = {};

  @observable showCategoryPopup = false;

  instagramApiToken = bf_config.instagramApiToken;
  facebookApiToken =  bf_config.facebookApiToken; // "308393142906850"; //"252908288575012";//

  socialApiToken = {
    facebook :  bf_config.facebookApiToken,//"252908288575012",//
    instagram : bf_config.instagramApiToken,
  }

  @observable socials = {
    facebook : {},
    instagram : {}
  };

  @observable socialPhotos = {
    facebook : {},
    instagram : {}
  };

  //@observable facebook = {};
  //@observable facebookPhotos = [];
  @observable socialGraphicOpen = false;

  @observable currentFont = {
    size : '',
    color: '',
    space: '',
    family : '',
    style : {
      fontWeight: 'normal',
      textDecoration: 'none',
      fontStyle: 'normal',
      textAlign: 'left'
    }
  }

  @observable panelsOnOff = true;
  @observable snapToElement = true;
  @observable panelPosition = 'right';
  @observable device = 'desktop';

  constructor(){


    $(window).on('WorkArea-deselectCanvasElem',()=>{
      this.settings = {};
      this.type = 'none';
      this.active = false;
      this.activeIdLayer = -1;
    })

    $(window).on('WorkArea-selectCanvasElemElement',(e,element)=>{

      this.instance = element.instance;
      this.settings = element;
      this.active = true;

      this.activeIdLayer = element.idLayer;

      if ( this.settings == null || this.settings == undefined ) { this.type = 'none'; }
      if ( this.settings.text != undefined )
      {
        this.type = 'text';
        this.currentFont.size =  this.instance.fontSize / 10;
        this.currentFont.space =  this.instance.charSpacing ?  ( this.instance.charSpacing / 10 ) : 0;
        this.currentFont.color =  this.instance.fill;
        this.currentFont.family = {
          label :  this.instance.fontFamily,
          type : 'element'
        }

        this.currentFont.style = {
          fontWeight: 'normal',
          textDecoration: 'none',
          fontStyle: 'normal',
          textAlign: 'left'
        }



      }
      else
      {
        this.type = 'image';
      }

      $(window).on('SingleProject-WideMode-on',()=>{
        this.setPanelPosition('bottom');
      })

    });

    if ( $(window).width() < 764 )
    {
      this.setDevice('mobile');
    }
    else
    {
      this.setDevice('desktop');
    }

    $(window).on('Dragging-ToolsArea',(e,val)=>{
      this.setPanelPosition(val);
    })

  }

  @computed get getSettingsMediaList(){
    return this.mediaList;
  }

  @computed get getSettingsMediaListCount(){
    return this.mediaList.length;
  }

  setSettingsMediaList(data){
    this.mediaList = data;
  }




  /* SOCIAL MEDIA - start  */

  setSettingsSocialGraphicOpen(val){
    this.socialGraphicOpen = val;
  }

  /*
  setSettingsSocialAccessToken(social_name,val){
    this.socials[social_name].accessToken = val;
  }
  */

  setSettingsSocial(social_name,val,open){
    this.socials[social_name] = val;
    this.socialGraphicOpen = open;
console.log('social_name',social_name);
    switch (social_name) {
      case 'facebook' :
        this.getPhotosFacebook();
        break;
      case 'instagram' :
        this.getPhotosInstagram();
        break;
    }


  }

  getSettingsSocialApiToken(social_name){
    return this.socialApiToken[social_name];
  }

  getSettingsSocialAccessToken(social_name){
    return this.socials[social_name].accessToken;
  }

  @computed get getSettingsSocial(){
    return this.social;
  }

  @computed get getSettingsSocialPhotos(){
    return this.socialPhotos;
  }

  /*
  @computed get getSettingsFacebook(){
    return this.social.facebook;
  }

  @computed get getSettingsFacebookPhotos(){
    return this.socialPhotos.facebook;
  }
  */

  /* SOCIAL MEDIA - end */

  /*
  getAlbums(){
    $.ajax({
      // cache: false,
      //'https://graph.facebook.com/v2.9/me/albums?fields=cover_photo,name&access_token=&suppress_response_codes=true'
      url:  'https://graph.facebook.com/v2.9/me/albums?fields=cover_photo,name&access_token='+this.getSettingsFacebookAccessToken()+'&suppress_response_codes=true',
      dataType: "json",
      method : "get",
      success: (data)=>
      {
        console.log('data',data);
      },
      error:(data)=>
      {

      }
    });
  }
  */

  getPhotosFacebook(){
    $.ajax({
      url:  'https://graph.facebook.com/v2.9/me/photos?fields=picture,images,source,width,height,id,name&type=uploaded&limit=10000&access_token='+this.getSettingsSocialAccessToken('facebook')+'&suppress_response_codes=true',
      dataType: "json",
      method : "get",
      success: (data)=>
      {
        let photos = [];
        _.map(data.data,(val,key)=>{
          let obj = val;
          obj.source = obj.images[0].source;
          photos.push(obj)
        })
        this.socialPhotos.facebook = photos;//data.data;

      },
      error:(data)=>
      {

      }
    });
  }

  getPhotosInstagram(){
   // console.log('get data instagram:'+this.getSettingsSocialAccessToken('instagram'));
    $.ajax({
      url:  'https://api.instagram.com/v1/users/self/media/recent/?access_token='+this.getSettingsSocialAccessToken('instagram')+'&count=99999',
      dataType: "json",
      method : "get",
      success: (data)=>
      {
          let photos = [];
          _.map(data.data,(val,key)=>{
            let obj = val;
            obj.picture = val.images.thumbnail.url;
            obj.source = val.images.thumbnail.url.replace('s150x150/','');
            photos.push(obj)
          })

          this.socialPhotos.facebook = photos;//data.data;

      },
      error:(data)=>
      {

      }
    });
  }


  @computed get getSettingsCurrentElementInstance(){
    return this.instance;
  }

  @computed get getSettingsFirstUpload(){
    return this.firstUpload;
  }

  setFirstUpload(val,autorun){

    this.firstUpload = val;
    this.firstUploadAutoRunUpload = autorun;
  }

  @computed get getSettingsFirstUploadAutoRunUpload(){
    return this.firstUploadAutoRunUpload;
  }


  @computed get getSettingsFirstUploadAccepted(){
    return this.firstUploadAccepted;
  }

  setFirstUploadAccepted(val){
    this.firstUploadAccepted = val;
  }

  setShowCategoryPopup(val){
    this.showCategoryPopup = val;
  }

  @computed get getSettingsShowCategoryPopup(){
    return this.showCategoryPopup;
  }



  @computed get getSettingsCurrentFont(){
    return this.currentFont;
  }

  setCurrentFontSize(val) {

    this.currentFont.size = val;
    $(window).trigger('Text-setFontSize',(val * 10));
  }

  setCurrentFontSpace(val) {
    this.currentFont.space = val;
    $(window).trigger('Text-setFontSpace',(val  * 10));
  }

  setCurrentFontFamily(val) {
    this.currentFont.family = val;
    $(window).trigger('Text-setFontFamily',toJS(this.currentFont.family).value);
  }

  setCurrentFontColor(val) {
    this.currentFont.color = val;
    $(window).trigger('Text-setColor',toJS( this.currentFont.color));
  }

  setCurrentFontStyle(key,val){
    let obj = {}
      switch(key) {
        case 'fontWeight':
          ( this.currentFont.style.fontWeight == 'bold') ? this.currentFont.style.fontWeight = 'normal' : this.currentFont.style.fontWeight = 'bold';
          obj[key] = this.currentFont.style.fontWeight;
          break;
        case 'textDecoration':
          (  this.currentFont.style.textDecoration == 'underline') ?  this.currentFont.style.textDecoration = 'none' :  this.currentFont.style.textDecoration = 'underline';
          obj[key] =  this.currentFont.style.textDecoration;
          break;
        case 'fontStyle':
          (  this.currentFont.style.fontStyle == 'italic') ?  this.currentFont.style.fontStyle = 'normal' :  this.currentFont.style.fontStyle = 'italic';
          obj[key] =  this.currentFont.style.fontStyle;
          break;
        case 'textAlign':
           this.currentFont.style.textAlign = val;
          obj[key] =  this.currentFont.style.textAlign;
          break;
      }

      $(window).trigger('Text-setFontObj',obj);
}


  @computed get getSettingsToolbarOpen(){
    return this.toolbarOpen;
  }
  setToolbarOpen(val) {
    this.toolbarOpen = val;
  }


  @computed get getSettingsActiveIdLayer(){
    return this.activeIdLayer;
  }

  @computed get getSettingsDevice(){
    return this.device;
  }

  setDevice(val) {
    this.device = val;
    if (this.device == 'desktop') this.panelsOn();
    else
      this.panelsOff();

    $(window).trigger('resize-event');
  }

  setPanelPosition(val){
      this.panelPosition = val;
      switch(val) {
        case 'right':
          $('.bf-tools-area').insertAfter($('.creator-area-container'));
          $('.bf-tools-area').removeClass('wide-mode');
          $('.creator-area-container').removeClass('wide-mode');
          $('body').removeClass('wide-mode');
          $('.bf-tools-area').removeClass('bf-tools-area-left');
          $(window).trigger('resize-event');
          break;
        case 'left':
          $('.bf-tools-area').insertBefore($('.creator-area-container'));
          $('.bf-tools-area').removeClass('wide-mode');
          $('.creator-area-container').removeClass('wide-mode');
          $('body').removeClass('wide-mode');
          $('.bf-tools-area').addClass('bf-tools-area-left');
          $(window).trigger('resize-event');
          break;
        case 'top':
          $('body').addClass('wide-mode');
          $('.bf-tools-area').addClass('wide-mode');
          $('.creator-area-container').addClass('wide-mode');
          $('.bf-tools-area').insertBefore($('.creator-area-container'));
          $(window).trigger('resize-event');
          break;
        case 'bottom':
          $('body').addClass('wide-mode');
          $('.bf-tools-area').addClass('wide-mode');
          $('.creator-area-container').addClass('wide-mode');
          $('.bf-tools-area').insertAfter($('.creator-area-container'));
          $(window).trigger('resize-event');
          break;

        default:

      }
  }

  @computed get getSettingsPanelPosition(){
    return this.panelPosition;
  }

  snapToElementOn(){
    this.snapToElement = true;
    $(window).trigger('Tools-enableSnap');
  }

  snapToElementOff(){
    this.snapToElement = false;
    $(window).trigger('Tools-disableSnap');
  }

  @computed get getSettingsSnapToElementOnOff(){
    return this.snapToElement;
  }

  panelsOn(){
    this.panelsOnOff = true;
    $('body').removeClass('REMOVED_TOOLSAREA');
  }

  panelsOff(){
    this.panelsOnOff = false;
    $('body').addClass('REMOVED_TOOLSAREA');
  }

  @computed get getSettingsPanelsOnOff(){
    return this.panelsOnOff;
  }

  @computed get getSettingsType(){
    return this.type;
  }

  @computed get getSettingsIsActive(){
    return this.active;
  }

  @computed get getSettingsIsActiveText(){
    return ( this.active && this.type == 'text' );
  }

  @computed get getSettingsIsActiveImage(){
    return ( this.active && this.type == 'image' );
  }

  setSettingsIsActive(val){
     this.active = val;
  }

}

const ce = new Settings();
export default ce;



